/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import Grid from "@mui/material/Grid";
import ValidatorSelectField from "@/src/components/FormFields/ValidatorSelectField";
import { emailDefault, requiredValidator } from "@/src/services/validationRules";
import MenuItem from "@mui/material/MenuItem";
import React from "react";
import EmailCheck from "@/src/components/EmailCheck/EmailCheck";
import ButtonLoading from "@/src/components/Button/ButtonLoading";
import ButtonTextTermsOfServicePrivacy from "@/src/components/Checkin/Common/ButtonTextTermsOfServicePrivacy/ButtonTextTermsOfServicePrivacy";
import trafficAccidentCheckinStyle from "./trafficAccidentCheckinStyle";
import { useForm } from "@/src/provider/Form/FormProvider";
import { translate } from "@/src/services/translations/translations";

type TrafficAccidentCheckinFormProps = {
  isLoading: boolean;
  emailErrorText: string;
  setEmailErrorText: (emailErrorText: string) => void;
};

export default function TrafficAccidentCheckinForm({ setEmailErrorText, emailErrorText, isLoading }: TrafficAccidentCheckinFormProps) {
  const { handleSubmit } = useForm();

  return (
    <form onSubmit={handleSubmit}>
      <Grid container columnSpacing={4}>
        <Grid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <ValidatorSelectField
            label={translate("trafficAccident.typeOfDamage.label", {})}
            name={"typeOfDamage"}
            validators={[requiredValidator("Bitte geben Sie die Art des Schadens an.")]}
          >
            <MenuItem value={"vehicle"}>{translate("trafficAccident.typeOfDamage.options.vehicle.label", {})}</MenuItem>
            <MenuItem value={"person"}>{translate("trafficAccident.typeOfDamage.options.person.label", {})}</MenuItem>
            <MenuItem value={"vehicleAndPerson"}>{translate("trafficAccident.typeOfDamage.options.vehicleAndPerson.label", {})}</MenuItem>
            <MenuItem value={"other"}>{translate("trafficAccident.typeOfDamage.options.other.label", {})}</MenuItem>
          </ValidatorSelectField>
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <EmailCheck
            name="email"
            label="Ihre E-Mail-Adresse"
            autoComplete="email"
            emailErrorText={emailErrorText}
            setEmailErrorText={setEmailErrorText}
            validators={[requiredValidator("Bitte geben Sie Ihre E-Mail-Adresse an"), emailDefault]}
            redirectProps={null}
          />
        </Grid>
        <Grid
          sx={trafficAccidentCheckinStyle.buttonContainer}
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <ButtonLoading variant="contained" color="primary" sx={trafficAccidentCheckinStyle.button} type="submit" fullWidth isLoading={isLoading}>
            Jetzt starten
          </ButtonLoading>
          <ButtonTextTermsOfServicePrivacy />
        </Grid>
      </Grid>
    </form>
  );
}
